<template>
  <div>
    <b-row>
      <b-col
          md="6"
          xl="6"
          class="mb-1"
      >
        <b-col
            md="12"
            xl="12"
            class="mb-1"
        >
          <b-card-code title="Allgemeine Informationen">
            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Addresskennung"
                >

                  <address-search
                      ref="Address1Id"
                      v-model="address.AddressId"
                      @keyup.enter="SelectAddress1ById($event)"
                  />

                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-form-group
                    label="Kontaktname"
                >
                  <div style="font-weight: bold">{{ address.Contact.Name }}</div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-code>
        </b-col>
        <b-col
            md="12"
            xl="12"
            class="mb-1"
        >
          <b-card-code title="Adressinformationen">

            <b-row>
              <b-col
                  md="12"
                  xl="12"
              >
                <b-form-group
                    label="Strasse"
                >
                  <div style="font-weight: bold">{{ address.Address.Street }}</div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Postleitzahl"
                >
                  <div style="font-weight: bold">{{ address.Address.ZipCode }}</div>
                </b-form-group>
              </b-col>
              <b-col
                  md="8"
                  xl="8"
              >
                <b-form-group
                    label="Ort"
                >
                  <div style="font-weight: bold">{{ address.Address.Location }}</div>
                </b-form-group>
              </b-col>
            </b-row>

          </b-card-code>
        </b-col>

        <b-col
            md="12"
            xl="12"
            class="mb-1"
        >
          <b-card-code title="Kontaktinformationen">

            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Telefon"
                >
                  <div style="font-weight: bold">{{ address.Contact.Phone }}</div>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Telefon"
                >
                  <div style="font-weight: bold">{{ address.Contact.Phone2 }}</div>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Fax"
                >
                  <div style="font-weight: bold">{{ address.Contact.Fax }}</div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-form-group
                    label="Email"
                >
                  <div style="font-weight: bold">{{ address.Contact.Email }}</div>
                </b-form-group>
              </b-col>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-form-group
                    label="Webseite"
                >
                  <div style="font-weight: bold">{{ address.Contact.Web }}</div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-code>
        </b-col>
      </b-col>
      <b-col
          md="6"
          xl="6"
          class="mb-1"
      >
        <b-col
            md="12"
            xl="12"
            class="mb-1"
        >
          <b-card-code title="Allgemeine Informationen">
            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Addresskennung"
                >
                  <address-search
                      ref="Address2Id"
                      v-model="address2.AddressId"
                      @keyup.enter="SelectAddress2ById($event)"
                  />

                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-form-group
                    label="Kontaktname"
                >
                  <div style="font-weight: bold">{{ address2.Contact.Name }}</div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-code>
        </b-col>
        <b-col
            md="12"
            xl="12"
            class="mb-1"
        >
          <b-card-code title="Adressinformationen">

            <b-row>
              <b-col
                  md="12"
                  xl="12"
              >
                <b-form-group
                    label="Strasse"
                >
                  <div style="font-weight: bold">{{ address2.Address.Street }}</div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Postleitzahl"
                >
                  <div style="font-weight: bold">{{ address2.Address.ZipCode }}</div>
                </b-form-group>
              </b-col>
              <b-col
                  md="8"
                  xl="8"
              >
                <b-form-group
                    label="Ort"
                >
                  <div style="font-weight: bold">{{ address2.Address.Location }}</div>
                </b-form-group>
              </b-col>
            </b-row>

          </b-card-code>
        </b-col>

        <b-col
            md="12"
            xl="12"
            class="mb-1"
        >
          <b-card-code title="Kontaktinformationen">

            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Telefon"
                >
                  <div style="font-weight: bold">{{ address2.Contact.Phone }}</div>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Telefon"
                >
                  <div style="font-weight: bold">{{ address2.Contact.Phone2 }}</div>
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Fax"
                >
                  <div style="font-weight: bold">{{ address2.Contact.Fax }}</div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-form-group
                    label="Email"
                >
                  <div style="font-weight: bold">{{ address2.Contact.Email }}</div>
                </b-form-group>
              </b-col>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-form-group
                    label="Webseite"
                >
                  <div style="font-weight: bold">{{ address2.Contact.Web }}</div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-code>
        </b-col>
      </b-col>
    </b-row>
    <b-row>
      <b-col
          md="12"
          xl="12"
      >
        <b-col
            md="12"
            xl="12"
        >
          <b-card-code
              v-for="(item, index) in items"
          >
            <b-row>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Min Personen"
                >
                  <b-form-input
                      v-model="item.MinPassengers"
                      @keyup.native="NumberOnly($event, /[^[0-9]/g)"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
                <b-form-group
                    label="Max Personen"
                >
                  <b-form-input
                      v-model="item.MaxPassengers"
                      @keyup.native="NumberOnly($event, /[^[0-9]/g)"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="2"
                  xl="2"
              >
              </b-col>
              <b-col
                  md="3"
                  xl="3"
              >
                <b-form-group
                    label="Preis"
                >

                  <b-form-input
                      v-model="item.Price"
                      @blur="ReformatEuro"
                      @keyup.native="NumberOnly($event, /[^.,[0-9]/g)"
                  />
                </b-form-group>
              </b-col>

              <b-col
                  md="3"
                  xl="3"
              >
                <b-form-group
                    label="Option"
                    class="float-right"
                >
                  <b-button-group
                  >
                    <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-danger"
                        @click="Remove(index)"
                    >
                      Löschen
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-success"
                        @click="Add"
                    >
                      Neuen Eintrag
                    </b-button>
                  </b-button-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-code>
        </b-col>
      </b-col>
    </b-row>
    <b-row>
      <b-col
          md="12"
          xl="12"
      >
        <b-col
            md="12"
            xl="12"
        >
          <b-card-code>
            <b-row>
              <b-col
                  md="3"
                  xl="3"
                  class="mb-2"
              >
                <b-button
                    variant="danger"
                    class="btn-block mt-2"
                    @click="Delete"
                >
                  löschen
                </b-button>

              </b-col>
              <b-col
                  md="3"
                  xl="3"
              >

              </b-col>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-button
                    variant="info"
                    class="btn-block mt-2"
                    @click="Save"
                >
                  Speichern
                </b-button>
              </b-col>
            </b-row>
          </b-card-code>
        </b-col>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BButtonGroup
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'
import AddressSearch from '@/views/extras/AddressSearch.vue'

export default {
  components: {
    AddressSearch,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BButtonGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    Cleave,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      identId: 0,
      items: [{
        MinPassengers: '',
        MaxPassengers: '',
        Price: 0,
      }],
      address: {
        AddressIdentId: 0,
        AddressId: '',
        Address: {
          Street: '',
          ZipCode: '',
          Location: '',
          District: ''
        },
        Contact: {
          Name: '',
          Phone: '',
          Phone2: '',
          Fax: '',
          Email: '',
          Web: ''
        },
      },
      address2: {
        AddressIdentId: 0,
        AddressId: '',
        Address: {
          Street: '',
          ZipCode: '',
          Location: '',
          District: ''
        },
        Contact: {
          Name: '',
          Phone: '',
          Phone2: '',
          Fax: '',
          Email: '',
          Web: ''
        },
      },
    }
  },
  mounted() {
    this.$watch(
        () => this.$refs.Address1Id.fieldSelected,
        val => {
          this.SelectAddress(val, 'Address1')
        },
    )
    this.$watch(
        () => this.$refs.Address2Id.fieldSelected,
        val => {
          this.SelectAddress(val, 'Address2')
        },
    )
    this.$nextTick(() => {
      document.title = 'Preisvariation'
    })
    if (this.$route.params.id > 0) {
      this.$http.get(`/address/price/variation/id?identId=${this.$route.params.id}`)
          .then(resp => {
            this.identId = resp.data.pv.IdentId
            this.items = resp.data.pv.List
            this.$http.get('/address/ident?identId=' + resp.data.pv.From)
                .then(resp => {
                  this.FillInputs(resp.data.address, 'Address1')
                })
                .catch(err => {
                  console.error(err)
                })
            this.$http.get('/address/ident?identId=' + resp.data.pv.To)
                .then(resp => {
                  this.FillInputs(resp.data.address, 'Address2')
                })
                .catch(err => {
                  console.error(err)
                })

          })
          .catch(err => {
            console.error(err)
          })
    }
  },
  methods: {
    ReformatEuro(event) {
      console.log(event)
      console.log(event.target.value)
      event.target.value = event.target.value.replace(/[^,-[0-9]/g, '')
          .replace(',', '.')
    },
    NumberOnly(event, regex) {
      event.target.value = event.target.value.replace(regex, '')
          .replace(',', '.')
    },
    Delete() {
      this.$swal({
        title: 'LÖSCHEN',
        text: 'Wirklich löschen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, löschen!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.value) {
              this.$http.delete(`/address/price/variation/delete?identId=${this.$route.params.id}`)
                  .then(resp => {
                    if (resp.data.success) {
                      this.$swal({
                        icon: 'success',
                        title: 'Gelöscht!',
                        text: 'Eintrag wurde unwiderruflich gelöscht.',
                        customClass: {
                          confirmButton: 'btn btn-success',
                        },
                      })

                      this.$router.push({ name: 'PriceVariationList' })

                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })
            }
          })
          .catch(err => {
            console.error(err)
          })

    },
    Save() {
      this.$http.post('/address/price/variation/add', JSON.stringify(
          {
            identId: this.identId,
            fromAddressIdentId: this.address.AddressIdentId,
            toAddressIdentId: this.address2.AddressIdentId,
            list: this.items
          }
      ))
          .then(resp => {
            if (resp.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Speichern',
                  icon: 'CheckIcon',
                  text: 'Eintrag wurde aktualisiert.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    Add() {
      this.items.push({
        MinP: '',
        MaxP: '',
        Price: 0,
      })
    },
    Remove(index) {
      this.items.splice(index, 1)
    },
    SelectAddress1ById(event) {
      if (event.keyCode == 13) {
        this.SelectAddress(this.address.AddressId, 'Address1')
        this.$nextTick(() => this.$refs.Address1Id.$el.select())
      }
    },
    SelectAddress2ById(event) {
      if (event.keyCode == 13) {
        this.SelectAddress(this.address2.AddressId, 'Address2')
        // this.$nextTick(() => this.$refs.DestinationPassengerNumber.$el.select())
      }
    },
    FillInputs(data, type) {
      let AddressFields = {}
      let ContactFields = {}
      if (type == 'Address1') {
        AddressFields = this.address.Address
        ContactFields = this.address.Contact
        this.address.AddressId = data.AddressId
        this.address.AddressIdentId = data.AddressIdentId

      }
      if (type == 'Address2') {
        AddressFields = this.address2.Address
        ContactFields = this.address2.Contact
        this.address2.AddressId = data.AddressId
        this.address2.AddressIdentId = data.AddressIdentId
      }

      AddressFields.Street = data.Address.Street
      AddressFields.ZipCode = data.Address.ZipCode
      AddressFields.Location = data.Address.Location
      AddressFields.District = data.Address.District
      ContactFields.Name = data.Contact.Name
      ContactFields.Phone = data.Contact.Phone
      ContactFields.Phone2 = data.Contact.Phone2
      ContactFields.Fax = data.Contact.Fax
      ContactFields.Web = data.Contact.Web
      ContactFields.Email = data.Contact.Email
    },
    SelectAddress(number, type) {
      this.$http.get('/address/' + number)
          .then(resp => {
            this.FillInputs(resp.data, type)
          })
          .catch(err => {
            console.error(err)
          })
    },
  },
}
</script>
